import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { createRefPath, createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import _ from 'lodash';
import React, { useContext, useEffect, useReducer } from 'react';
import { AppComponentContext } from '../../../../global/cnr/contexts/AppComponentContext';
import { DatabaseContext } from '../../../../global/cnr/contexts/DatabaseContext';
import { createAppStaticViews } from '../../../../global/firestoreData/staticViews/updateStaticViews';
import { golfTournamentHandlers, golfTournamentInitialState, golfTournamentReducer } from '../reducers/GolfTournamentReducer';
import { useGolf } from 'projectSpecific/golf/useHelpers/useGolf';
import { userRandomMatchScoring } from 'projectSpecific/golf/useHelpers/userRandomMatchScoring';

export const GolfTournamentContext = React.createContext()

/**
 * @provides teams 
 * @provides golfCourse  
 * @provides holes 
 * @provides golfMatchData  
 * @provides roundsStatus 
 * @provides golfTournament_handlers 
 * @provides golfTeam1
 * @provides golfTeam2
 * @provides golfTeam1Style
 * @provides golfTeam2Style
 */

const GolfTournamentProvider = (props) => {

  const { golfTournamentKey, golfTournament: golfTournament_fromList } = props ?? {}

  const { get_golfTournamentData } = useGolf()

  // golfParentContext 
  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state, currentSettings_state } = states ?? {}

  const { aps_viewItems } = _.get(currentSettings_state, 'gvviSettings', {});

  // databaseContext
  const databaseContext = useContext(DatabaseContext)
  const { database_fns } = databaseContext ?? {}

  // papsContext 
  const { pathViews, viewKey } = paps_state ?? {}

  // let viParentKey;
  let viSubKeys;

  if (aps_viewItems) {
    Object.keys(aps_viewItems).forEach(viKey => {
      const { dataConnection } = aps_viewItems[viKey]
      const { startParentData, startDataPages } = dataConnection ?? {}
      if (startParentData) {
        // viParentKey = viKey
        viSubKeys = startDataPages
      }
    })
  }

  // golfEventContext
  const golfEventContext = useContext(AppComponentContext)
  const { golfEvent_state } = golfEventContext ?? {}
  const { golfTournaments } = golfEvent_state ?? {}

  // local state  
  const init_state = { viewKey, golfEvent_state }
  const [golfTournament_state, golfTournament_dispatch] = useReducer(golfTournamentReducer, init_state, golfTournamentInitialState)
  const golfTournament_handlers = golfTournamentHandlers(golfTournament_dispatch, golfTournament_state)
  const { golfTournament, golfCourse, details, roundsStatus, autoScoringRoundKey, matches_rounds } = golfTournament_state ?? golfTournament_state
  const { allowTempAccess } = golfTournament ?? {}
  const { rounds: rounds_details, teams: teams_details, lineups: lineups_details } = details ?? {}
  const { handleStop_autoScoring } = golfTournament_handlers ?? {}

  const { startRandomMatchScoring, stopRandomMatchScoring, rmsStarted } = userRandomMatchScoring({ handleAmmend_matchUpdater: {} })

  useEffect(() => {
    if (autoScoringRoundKey) {
      if (rmsStarted) return;
      startRandomMatchScoring({ golfTournament_state, teams: teams_details, matches_rounds, roundsStatus, roundKey: autoScoringRoundKey, handleStop_autoScoring })
    } else {
      stopRandomMatchScoring()
    }
  }, [autoScoringRoundKey]);

  // useEffect(
  //   () => {
  //     if (golferRecords) {
  //       const partners = {}
  //       _.forEach(golferRecords, (gr, grKey) => {
  //         partners[grKey] = gr?.partners
  //       })
  //       if (_updatePlayerRecords) {
  //         const ref = createRefPath_event(pathViews, ['golfer_partners', golfTournament.id])
  //         database_fns.doc_set(ref, partners, true)
  //       }
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps  
  //   }, [golferRecords]
  // )

  useEffect(
    () => {
      if (allowTempAccess) {
        const cb = (res) => {
          golfTournament_handlers.handleAmmend_tempAppUserAccess(res)
        }
        const refPath = createRefPath(['_accessTemp', golfTournament.id])
        database_fns.get_doc({ refPath, callback: cb, opts: { ignoreId: true } })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, [allowTempAccess]
  )

  useEffect(() => {
    const cb_gt = (tournamentInfo) => {
      golfTournament_handlers.handleAmmend_tournamentInfo(tournamentInfo)

    }
    if (pathViews.golfTournaments) {
      get_golfTournamentData({ golfTournamentKey: null, callback: cb_gt })
      // golfTournament_handlers.handleGet_golfTournamentData()
    } else if (golfTournamentKey) {
      get_golfTournamentData({ golfTournamentKey, callback: cb_gt })
      // golfTournament_handlers.handleGet_golfTournamentData(null, golfTournamentKey)
    } else if (golfTournament_fromList) {
      const gtl = golfTournaments && golfTournaments[golfTournament_fromList] ? golfTournaments[golfTournament_fromList] : null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  useEffect(() => {
    if (golfTournament && rounds_details && teams_details && golfCourse) {
      golfTournament_handlers.handleSet_initGolfTournament()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [golfTournament, rounds_details, golfCourse, teams_details, pathViews.golfTournaments]);

  // useEffect(
  //   () => {
  //     if (matches && golfers) {
  //       golfTournament_handlers.handleSet_golferRoundMatches()
  //     }
  //     // eslint-disable-next-line react-hooks/exhaustive-deps  
  //   }, [matches, golfers]
  // )

  if (golfTournament && rounds_details && teams_details && lineups_details && roundsStatus) {
    const appStaticViews = createAppStaticViews(golfTournament_state, viSubKeys, aps_viewItems)
    return <GolfTournamentContext.Provider value={{ golfTournament_handlers, golfTournament_state, appStaticViews }}>
      {props.children}
    </GolfTournamentContext.Provider>
  } else {
    return <GolfTournamentContext.Provider value={{ golfTournament_handlers, golfTournament_state }}>
      {props.children}
    </GolfTournamentContext.Provider>
  }
};

export default GolfTournamentProvider